var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "138 438 205 205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0065ff",
    fillRule: "evenodd",
    d: "M 280.49 540.79 C 280.49 556.24 255.80 580.93 240.35 580.93 C 224.90 580.93 200.21 556.24 200.21 540.79 C 200.21 525.34 224.90 500.65 240.35 500.65 C 255.80 500.65 280.49 525.34 280.49 540.79 M 340.70 540.79 C 340.70 579.41 278.97 641.14 240.35 641.14 C 201.73 641.14 140 579.41 140 540.79 C 140 502.17 201.73 440.43 240.35 440.43 C 278.97 440.43 340.70 502.17 340.70 540.79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.f80a7fd5895772b0b76f8aa603e7cfc3.svg";
export { ForwardRef as ReactComponent };